module.exports = "<div class=\"search-zero-results-wrapper\">\r\n    <h1 class=\"search-zero-results-wrapper-header\">No {{ $ctrl.pageName}} found</h1>\r\n    <div class=\"search-zero-results-wrapper-blurb\">\r\n        <span ng-bind-html=\"$ctrl.emptyProductSearchMessageBefore\"></span>\r\n        {{ $ctrl.searchTerm }}\r\n        <span ng-bind-html=\"$ctrl.emptyProductSearchMessageAfter\"></span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/search/search-zero-results.component.html
// module id = 1015
// module chunks = 0